var map = {
	"./ai-and-data-engineering.jpg": 310,
	"./bear.jpg": 311,
	"./cloud-computing.jpg": 312,
	"./cpp-in-production.jpg": 313,
	"./diac-background.jpg": 314,
	"./full-stack-development.jpg": 315,
	"./jason.jpg": 316,
	"./logan.jpg": 317,
	"./lu.jpg": 318,
	"./product-management.jpg": 319,
	"./self-driving-car.jpg": 320,
	"./software-development.jpg": 321,
	"./sun.jpg": 322,
	"./ui-ux-design.jpg": 323,
	"./yan.jpg": 324,
	"./zhao.jpg": 325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;